<template>
    <div class="home md-layout md-alignment-top-center">
    <md-card class="md-layout-item md-size-65">
      <md-card-header>
        <h1 class="md-title">Please login to view the student bank</h1>
      </md-card-header>
    </md-card>
    </div>
</template>

<script>
export default {
    name: "login"
}
</script>
